<template>
    <modal-crud
        :title=title
        v-on:close="$emit('close')"
        :isLoading=isLoading>
        <section class="modal-card-body">
            <pick-list v-model="aplicacoes" listStyle="height:342px" dataKey="id">
                <template #sourceheader>
                    Disponíveis
                </template>
                <template #targetheader>
                    Selecionados
                </template>
                <template #item="slotProps">
                    <div class="p-caritem">
                        <div>
                            <span>{{slotProps.item.application_name}} - {{slotProps.item.ambiente}}</span>
                        </div>
                    </div>
                </template>
            </pick-list>
        </section>
        <div slot="buttons">
            <b-button
                label="Salvar"
                type="is-primary"
                @click="sync" />
        </div>
    </modal-crud>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalCrud from '@/components/Layout/ModalCrud.vue';
import state from '@/modules/auth/store/state';
import services from '@/http';
import PickList from 'primevue/picklist';
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import _ from 'lodash';

@Component({
    components: {
        "modal-crud":ModalCrud,
        "pick-list":PickList,
    },
})

export default class LinkApplication extends Vue { 
    @Prop({default: {}}) token
    @Prop({default: ''}) title

    data() {
        return {
            isLoading: false,
            aplicacoes: []
        }
    }

    mounted() {
        this.getAplicacoes()
    }

    getAplicacoes() {
        this.isLoading = true;

        services.application.list()
            .then(res => {
                var ambientes       = [];
                var ambientesToken  = this.token.ambientes;

                if (res.data.data) {
                    _.forEach(res.data.data, function(value) {
                        ambientes.push(...value.ambientes);
                    });

                    _.forEach(ambientesToken, function(ambiente) {
                        let id = _.get(ambiente, 'id')

                        _.remove(ambientes, {id});
                    })
                }
                
                this.aplicacoes = [ambientes, ambientesToken];
            }).catch(err => {           
                this.flash('danger', err.body.message)
            })
            .finally(()=>{
                this.isLoading = false;
            });
    }

    sync() {
        var data = {
            client_id: this.token.id,
            ambientes: this.aplicacoes[1],
            userId: state.user.id            
        }

        this.isLoading = true;

        services.token.linkApplication(data)
            .then(res => {
                this.$root.flashSuccess('Vínculado com sucesso!')

                this.$emit('close');               
                this.$emit('refreshList');               
            }).catch(err => {
                this.$root.flashError(err)
            })
            .finally(()=>{
                this.isLoading = false;
            });
    }
}
</script>